import React from 'react';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import PresentToAllIcon from '@material-ui/icons/PresentToAll';
import CardHeader from 'src/components/sharedComponents/Card/CardHeader';
import Card from 'src/components/sharedComponents/Card/Card';
import CardFooter from 'src/components/sharedComponents/Card/CardFooter';
import CardBody from 'src/components/sharedComponents/Card/CardBody';
import CardTitle from 'src/components/sharedComponents/CardTitle';
import CardIcon from 'src/components/sharedComponents/Card/CardIcon';
import Button from 'src/components/sharedComponents/CustomButtons/Button';
import DataPikers from '@auteco/components/sharedComponents/DataPikers';

const MobilityReports = ({
  loading2, handleSubmit, onChangeData, newDate,
}) => {
  const DATE = new Date();
  const MONTH = DATE.getMonth();
  const YEAR = DATE.getFullYear();
  const DAY = DATE.getDate();

  const MIN_DATE = new Date(YEAR - 5, MONTH, DAY);

  return (
    <>
      <CardTitle title="Reportes Mobility " />
      <Grid container justifyContent="center" spacing={2}>
        <Grid item xs={12} md={8} sm={12}>
          <form
            noValidate
            autoComplete="off"
            onSubmit={handleSubmit}
          >
            <Card style={{ marginLeft: '10px' }}>
              <CardHeader color="customAuteco" stats icon>
                <CardIcon color="customAuteco">
                  <PresentToAllIcon />
                </CardIcon>
              </CardHeader>
              <CardBody>
                <Grid style={{ marginLeft: '5px' }} container spacing={2}>
                  <Grid item xs={12} md={12} sm={12}>
                    <DataPikers
                      autoOk
                      variant="inline"
                      placeholder="Año/Mes/Dia"
                      format="yyyy/MM/dd"
                      margin="normal"
                      value={newDate.fecha_0}
                      id="date-picker-inline"
                      label="Fecha inicial"
                      minDateMessage="5 años atras a partir del año en curso"
                      maxDateMessage="No puedes seleccionar una fecha futura"
                      invalidDateMessage="Selecciona una fecha valida"
                      disableFuture
                      onChange={(date) => onChangeData('fecha_0', date)}
                      minDate={MIN_DATE}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} md={12} sm={12}>
                    <DataPikers
                      autoOk
                      variant="inline"
                      placeholder="Año/Mes/Dia"
                      format="yyyy/MM/dd"
                      margin="normal"
                      minDateMessage="La fecha final no puede ser menor que la fecha inicial"
                      maxDateMessage="No puedes seleccionar una fecha futura"
                      invalidDateMessage="Selecciona una fecha valida"
                      label="Fecha final"
                      disableFuture
                      onChange={(date) => onChangeData('fecha_1', date)}
                      minDate={newDate.fecha_0}
                      value={newDate.fecha_1}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} md={12} sm={12}>
                    <CardFooter>
                      {loading2 ? (
                        <>
                          <span>Generando Reporte, espere...</span>
                          <CircularProgress />
                        </>
                      ) : (
                        <Button type="onSubmit " color="warning">
                          Descargar Reporte
                        </Button>
                      )}
                    </CardFooter>
                  </Grid>
                </Grid>
              </CardBody>
            </Card>
          </form>
        </Grid>
      </Grid>
    </>
  );
};

export default MobilityReports;
